import Model from '@/models/Model.js';

export const LECTURE = 'onsite-lecture';
export const LAB = 'lab';
export const OFFSITE_WITH_INSTRUCTOR = 'offsite-with-instructor';
export const OFFSITE_WITHOUT_INSTRUCTOR = 'offsite-without-instructor';
export const ONLINE = 'online';

export default class AttendanceScenario extends Model {
    static entity = 'attendance_scenarios';

    static modelName = 'AttendanceScenario';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            description: this.attr(null),
            coursekey_attendance_name: this.attr(null),

            ...super.fields(),
        };
    }
}
